import './ScenesStyles.scss';
import React, { useEffect, useLayoutEffect, useRef } from 'react';
import useGsapContext from '../../../hooks/UseGsapContext';
import gsap from 'gsap';
import ModalBtn from '../../ModalScene/ModalBtn';
import { useDispatch, useSelector } from 'react-redux';
import { selectScene, setActive } from 'src/app/redux/slice/sceneSlice';
import ScrollControls from '../../MobileControls/MobileControls';

const scenesImages = require.context('../../../../assets/scenes');

// MOBILE QUERIES-HEIGHT
const sm = window.matchMedia('(min-height: 787px)');

// DESKTOP
const lg = window.matchMedia('(min-width: 978px)');
const xl = window.matchMedia('(min-width: 1200px)');
const xxl = window.matchMedia('(min-width: 1400px)');
const xxxl = window.matchMedia('(min-width: 1600px)');

const SceneDesktop = ({ data, fs, allowScroll, blockScroll }) => {
  const newCurrentScene = useSelector(
    (state) => state.sceneController.newCurrentScene
  );
  const dispatch = useDispatch();

  const isEnableNextSection = useRef(false);
  const isBack = useRef(false);

  const scene = useRef();
  const pinContent = useRef();
  const collageRef = useRef();

  const titleRef = useRef();
  const textBoxRef = useRef();

  const ctx = useGsapContext(scene);
  // Change Scene & Animation
  const changeScene = (progress) => {
    if (progress > 0.005 && !isBack.current && lg.matches) {
      isBack.current = true;
    }
    if (progress <= 0.0000005 && isBack.current && lg.matches) {
      blockScroll();
      if (newCurrentScene !== '01') {
        gsap.to(scene.current, {
          opacity: 0,
          duration: 0.8,
        });
      }
      setTimeout(() => {
        isEnableNextSection.current = false;
        isBack.current = false;
        dispatch(selectScene(data?.sceneTransition?.prev));
        dispatch(setActive(false));
      }, 800);
    }
    if (progress == 1 && !isEnableNextSection.current && lg.matches) {
      setTimeout(() => {
        window.scrollTo(0, 1950);
        isEnableNextSection.current = true;
        dispatch(setActive(true));
      }, 300);
    }

    if (progress == 1 && isEnableNextSection.current && lg.matches) {
      dispatch(setActive(false));
      gsap.to(scene.current, {
        opacity: 0,
        duration: 0.8,
      });
      blockScroll();
      setTimeout(() => {
        isEnableNextSection.current = false;
        dispatch(selectScene(data?.sceneTransition?.next));
      }, 800);
    }
  };
  // Animations
  useLayoutEffect(() => {
    ctx.add(() => {
      const parallax = gsap.utils.toArray('.parallax');
      // Initial position
      gsap.set(scene.current, {
        opacity: 0,
      });

      // START ANIMATION
      const start = gsap.timeline({
        duration: 0.5,
      });
      start.to(window, {
        duration: 0,
        scrollTo: 18,
        ease: 'none',
      });
      start.to(scene.current, {
        opacity: 1,
      });

      const tl = gsap.timeline(
        {
          scrollTrigger: {
            trigger: pinContent.current,
            scrub: true,
            pin: true,
            start: 'top top',
            invalidateOnRefresh: false,
            end: '+=2000',
            onUpdate: (self) => changeScene(self.progress),
          },
        },
        scene
      );
      setTimeout(() => {
        // XXXL -> 1600
        if (xxxl.matches) {
          parallax.forEach((item) => {
            tl.to(
              item,
              {
                marginTop: 0,
                ease: 'none',
              },
              '<'
            );
          });
          tl.to(
            titleRef.current,
            {
              y:
                -textBoxRef.current.offsetHeight -
                titleRef.current.offsetHeight +
                window.innerHeight -
                90,
              duration: 1,
            },
            '<'
          );
          tl.to(
            textBoxRef.current,
            {
              y:
                -textBoxRef.current.offsetHeight -
                titleRef.current.offsetHeight +
                window.innerHeight -
                90,
              duration: 1,
            },
            '<'
          );
        }
        // XXL -> 1400
        if (xxl.matches && !xxxl.matches) {
          parallax.forEach((item) => {
            tl.to(
              item,
              {
                marginTop: 0,
                ease: 'none',
              },
              '<'
            );
          });
          tl.to(
            titleRef.current,
            {
              y:
                -textBoxRef.current.offsetHeight -
                titleRef.current.offsetHeight +
                window.innerHeight -
                90,
              duration: 1,
            },
            '<'
          );
          tl.to(
            textBoxRef.current,
            {
              y:
                -textBoxRef.current.offsetHeight -
                titleRef.current.offsetHeight +
                window.innerHeight -
                90,
              duration: 1,
            },
            '<'
          );
        }
        // XL -> 1200
        if (xl.matches && !xxl.matches && !xxxl.matches) {
          if (!sm.matches) {
            parallax.forEach((item) => {
              tl.to(
                item,
                {
                  marginTop: 0,
                  ease: 'none',
                },
                '<'
              );
            });
          }
          if (sm.matches) {
            parallax.forEach((item) => {
              tl.to(
                item,
                {
                  marginTop: 100,
                  ease: 'none',
                },
                '<'
              );
            });
          }
          tl.to(
            titleRef.current,
            {
              y:
                -textBoxRef.current.offsetHeight -
                titleRef.current.offsetHeight +
                window.innerHeight -
                90,
              duration: 1,
            },
            '<'
          );
          tl.to(
            textBoxRef.current,
            {
              y:
                -textBoxRef.current.offsetHeight -
                titleRef.current.offsetHeight +
                window.innerHeight -
                90,
              duration: 1,
            },
            '<'
          );
        }
        // LG -> 925
        if (lg.matches && !xl.matches && !xxl.matches && !xxxl.matches) {
          parallax.forEach((item) => {
            tl.to(
              item,
              {
                marginTop: 50,
                ease: 'none',
              },
              '<'
            );
          });
          tl.to(
            titleRef.current,
            {
              y:
                -textBoxRef.current.offsetHeight -
                titleRef.current.offsetHeight +
                window.innerHeight -
                90,
              duration: 1,
            },
            '<'
          );
          tl.to(
            textBoxRef.current,
            {
              y:
                -textBoxRef.current.offsetHeight -
                titleRef.current.offsetHeight +
                window.innerHeight -
                90,
              duration: 1,
            },
            '<'
          );
        }
      }, 500);
    });
    return () => ctx.revert();
  });

  useEffect(() => {
    isBack.current = false;
    isEnableNextSection.current = false;
    allowScroll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <div
      className={
        (newCurrentScene - 1) % 2 ? 'dark-mode container' : 'container'
      }
      ref={scene}
    >
      <div
        ref={pinContent}
        style={{
          height: '100vh',
        }}
        className="scene"
      >
        <div className="scene-title" ref={titleRef}>
          <h2 className="" style={{ fontSize: `calc(1em + ${fs})` }}>
            {data?.title}
          </h2>
        </div>
        <div className="scene-collage" ref={collageRef}>
          <div className="scene-collage-parallax">
            <img
              aria-hidden="true"
              className="img1 parallax"
              data-depth={'0.20'}
              src={scenesImages(data?.collage?.img1?.url)}
              alt=""
              width="321px"
            />
            <img
              className="img2 parallax"
              width="321px"
              height={'auto'}
              data-depth={'0.18'}
              src={scenesImages(data?.collage?.img2?.url)}
              alt="Collage: precursores de CIAT realizando una planacion para el desarrollo de la empresa"
            />
            <img
              aria-hidden="true"
              className="img3 parallax"
              data-depth={'0.17'}
              src={scenesImages(data?.collage?.img3?.url)}
              width="321px"
              alt=""
            />
          </div>
        </div>
        <div className="scene-textbox" ref={textBoxRef}>
          <h3 className="">
            {data?.subtitle}
            <br />
            {data?.date}
          </h3>
          {data?.description?.map((item, index) => (
            <div
              className="scene-textbox-format"
              key={`${index}`}
              dangerouslySetInnerHTML={{ __html: item }}
            ></div>
          ))}
          <ModalBtn data={data?.options} title="Conoce más" />
          <ScrollControls
            prev={data?.sceneTransition?.prev}
            next={data?.sceneTransition?.next}
          />
        </div>
      </div>
    </div>
  );
};

export default SceneDesktop;
